// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sk-modal--invoice .payment-method .sk-select__list {\n  top: -2px;\n  max-height: 200px;\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n}\n", ""]);
// Exports
module.exports = exports;
